import React, {Component} from 'react';
import styled from "styled-components";
// import PropTypes from 'prop-types';

import {MAIN_APP} from '../MidiPlay.jsx';

import Colors from '../resource/ResourceColors.jsx';
import InterfaceIconList from '../interface/InterfaceIconList.jsx';

import UtilIcon from '../util/UtilIcon.jsx';

import UtilMidi from '../util/UtilMidi.jsx';
import UtilForm from '../util/UtilForm.jsx';

import StoreS3 from '../util/store/StoreS3.jsx';

const FOLDER_ICON = <UtilIcon
    icon={"folder"}
    bgColor={Colors.hue(33, 80)}
    color={Colors.primary(40)}
    absSize={"1.25rem"}
/>;
const FILE_ICON = <UtilIcon
    icon={"file"}
    bgColor={Colors.primary(95)}
    color={Colors.primary(40)}
    absSize={"1.1rem"}
    style={{marginTop: '0.15rem'}}
/>;

const FileListBody = styled.div`
    padding: 0.25rem;
`;

const FileListPrompt = styled.div`
    font-size: 1rem;
`;

export class MenuOpen extends Component {

    state = {
        remote_path: '',
        input_ref: React.createRef()
    };

    listen_dropdown(item) {
        item.handler()
        MAIN_APP.setState({dropdown: null});
    }

    handle_open_file_disk(item) {
        this.state.input_ref.current.click();
    }

    open_file_s3_body(folders, files) {

        let all_rows = [];
        folders.map((f, key) => {
            let name = f.Prefix.slice(0, -1);
            return name.substring(name.lastIndexOf("/") + 1);
        }).sort((a, b) => {
            return a.localeCompare(b);
        }).forEach(name => {
            all_rows.push({text: name, icon: FOLDER_ICON});
        });

        const text_style = {marginTop: '0.20rem'};
        const icon_style = {marginLeft: '0.15rem', marginTop: '-0.05rem', marginRight: '0.35rem'};
        files.map((f, key) => {
            return f.Key.substring(f.Key.lastIndexOf("/") + 1);
        }).sort((a, b) => {
            return a.localeCompare(b);
        }).forEach(name => {
            if (name) {
                all_rows.push({
                    text: name,
                    text_style: text_style,
                    icon: FILE_ICON,
                    icon_style: icon_style
                });
            }
        });

        return <FileListBody>
            <FileListPrompt>Select a file or project to open:</FileListPrompt>
            <InterfaceIconList rows={all_rows}/>
        </FileListBody>;
    }

    async handle_open_file_s3() {
        const all_files = await StoreS3.list_files('fracto/orbitals/01/10/');
        console.log('this', this);
        const contents = this.open_file_s3_body(all_files.CommonPrefixes, all_files.Contents);
        MAIN_APP.setState({
            modal: <UtilForm
                title={'Open File on AWS'}
                width={"20rem"}
                handler={async (results) => {
                    console.log('results are', results);
                    MAIN_APP.setState({modal: null});
                    if (results) {
                        const data = await StoreS3.get_file(results);
                        const events = UtilMidi.events_from_midi(data.Body);
                        MAIN_APP.load_file_events(events);
                    }
                }}
                contents={contents}
            />
        });
    }

    handle_open_file_drive(e) {
    }

    handle_open_file_ftp(e) {
    }

    get_options() {
        return [
            {
                label: "in S3 Bucket...",
                id: 'open-file-s3-menu-item',
                handler: (e) => this.handle_open_file_s3()
            },
            {type: "separator"},
            {
                label: "on Local Disk...",
                id: 'open-file-disk-menu-item',
                handler: (e) => this.handle_open_file_disk()
            },
            {
                label: "in Drive Bucket...",
                id: 'open-file-drive-menu-item',
                handler: this.handle_open_file_drive
            },
            {
                label: "on FTP Server...",
                id: 'open-file-drive-menu-item',
                handler: this.handle_open_file_ftp
            }
        ];
    }

    getMidiFile = async (e) => {
        const reader = new FileReader()
        let file_meta = {};
        if (e.target.files) {
            file_meta = e.target.files[0];
            reader.readAsArrayBuffer(e.target.files[0])
        }
        reader.onload = async (e) => {
            const events = UtilMidi.events_from_midi(e.target.result);
            MAIN_APP.load_file_events(events, file_meta);
        };
    }

    render() {
        const input_style = {position: 'absolute', top: "-10rem"}
        return <div>
            <input
                type="file"
                ref={this.state.input_ref}
                onChange={(e) => this.getMidiFile(e)}
                style={input_style}/>
        </div>
    }
}

export default MenuOpen;